export const NavigationRoots = {
  RootApp: "app",
};
